import { transitions } from '../transitions.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function(obj, key, value) {
    return key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var __spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (__getOwnPropSymbols) try {
        for(var _iterator = __getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
};
var transitionStatuses = {
    entering: "in",
    entered: "in",
    exiting: "out",
    exited: "out",
    "pre-exiting": "out",
    "pre-entering": "out"
};
function getTransitionStyles(param) {
    var transition = param.transition, state = param.state, duration = param.duration, timingFunction = param.timingFunction;
    var shared = {
        transitionDuration: "".concat(duration, "ms"),
        transitionTimingFunction: timingFunction
    };
    if (typeof transition === "string") {
        if (!(transition in transitions)) {
            return null;
        }
        return __spreadValues(__spreadValues(__spreadValues({
            transitionProperty: transitions[transition].transitionProperty
        }, shared), transitions[transition].common), transitions[transition][transitionStatuses[state]]);
    }
    return __spreadValues(__spreadValues(__spreadValues({
        transitionProperty: transition.transitionProperty
    }, shared), transition.common), transition[transitionStatuses[state]]);
}
export { getTransitionStyles }; //# sourceMappingURL=get-transition-styles.js.map
